<!--
 * @Description:
 * @Author: miao.zhang
 * @Date: 2020-11-20 13:45:38
 -->
<template>
  <el-form ref="searchFormModal" class="ts-form" :model="searchForm">
    <div v-for="(item, index) in formList" :key="index">
      <el-form-item v-if="item.type === 'input'" :ref="item.prop" :rules="item.rules" :label="item.label" :prop="item.prop">
        <el-input v-if="item.isNumber" v-model.number="searchForm[item.prop]" :disabled="isEcho && !item.isEdit" :placeholder="item.placeholder || ''" />
        <el-input v-else v-model="searchForm[item.prop]" :disabled="isEcho && !item.isEdit" :placeholder="item.placeholder || ''" />
      </el-form-item>
      <el-form-item v-if="item.type === 'select'" :ref="item.prop" :rules="item.rules" :label="item.label" :prop="item.prop">
        {{ item.change }}
        <el-select v-model="searchForm[item.prop]" :disabled="isEcho && !item.isEdit" :multiple="item.multiple || false" :placeholder="item.placeholder || ''" :clearable="false">
          <el-option v-for="(option, dx) in item.options" :key="dx" :label="option.anotherName || option.name" :value="option.id" :disabled="option.disabled" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="item.type === 'datePicker'" :ref="item.prop" :rules="item.rules" :label="item.label" :prop="item.prop">
        <el-date-picker
          v-model="searchForm[item.prop]"
          :type="item.dateType"
          :placeholder="item.placeholder"
        />
      </el-form-item>
      <el-form-item v-if="item.type === 'checkbox'" :ref="item.prop" :rules="item.rules" :label="item.label" :prop="item.prop">
        <el-checkbox-group v-model="searchForm[item.prop]" :disabled="isEcho && !item.isEdit" :placeholder="item.placeholder || ''">
          <el-checkbox v-for="(option, dx) in item.options" :key="dx" :label="option.id">
            {{ option.name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="item.type === 'radio'" :ref="item.prop" :rules="item.rules" :label="item.label" :prop="item.prop">
        <el-radio v-for="(option, dx) in item.options" :key="dx" v-model="searchForm[item.prop]" :label="option.id">
          {{ option.name }}
        </el-radio>
      </el-form-item>
       <!-- <el-form-item :label="'总计55年'" >

      </el-form-item> -->

    </div>
    <div class="dialog-footer">
      <el-button style="margin-left: 20px;" @click="closeDialog('noValue')">
        取 消
      </el-button>
      <el-button type="primary" @click="closeDialog('hasValue')">
        确 定
      </el-button>
    </div>
  </el-form>
</template>

<script>
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
@Component({
  name: 'TsForm',
  components: {
  }
})
export default class extends Vue {
  @Prop({ default: Array }) formList
  @Prop({ default: false }) isEcho
  @Prop({ default: Object }) name
  @Prop({ default: Object }) searchFormData
  searchForm = {
    activationCodeId: '',
    activationCodeIds: []
  }// checkboxGroup必须提前声明 否则报错

  @Watch('searchForm.activationCodeIds')
  handleCheckChange (newV) {
    const list = []
    if (newV && newV.length) {
      newV.forEach(id => {
        const its = this.formList[5].options.length ? this.formList[5].options.find(it => it.id === id) : {}
        if (its && its.id) {
          list.push(its)
        } else {
          let item = this.formList[4].options.find(option => option.id === id)
          item = Object.assign({}, item, {
            anotherName: item.name + '  ' + item.effectDays + '天'
          })
          delete item.disabled
          list.push(item)
        }
      })
    }
    console.log(list)
    const arr = list.filter(item => item.id === this.searchForm.activationCodeId)
    if (!arr.length) {
      this.searchForm.activationCodeId = ''
    } else {
      this.searchForm.activationCodeId = arr[0].id
    }
    this.$emit('activationCodes', list)
  }

  closeDialog (type) {
    if (type === 'noValue') {
      if (!this.isEcho) {
        for (const key in this.searchForm) {
          if (this.$refs[key]) {
            this.$refs[key][0].resetField()
          }
        }
      }
      this.$emit('close-dialog', type, this.searchForm)
    } else {
      this.$refs.searchFormModal.validate((valid) => {
        if (valid) {
          const list = []
          this.searchForm.userRoles.forEach(item => {
            list.push({ roleId: item })
          })
          let params = Object.assign({}, this.searchForm, {
            userRoles: list
          })
          if (!this.searchForm.tenantId) {
            params = Object.assign({}, params, {
              tenantId: window.sessionStorage.getItem('tenantId')
            })
          }
          this.name(params).then(res => {
            if (res.statusCode === 0 && res.data) {
              this.$emit('close-dialog', type, this.searchForm)
              this.$emit('input', false)
              this.$refs.searchFormModal.resetFields()
            } else {
              console.log(11111111)
            }
          })
        }
      })
    }
  }

  mounted () {
    if (this.isEcho) {
      this.searchForm = this.searchFormData
    }
  }
}
</script>

<style lang="scss">
.ts-form {
  .el-select {
    width: 100%;
    .el-select__tags {
      .el-tag--info {
        .el-tag__close {
          display: none;
        }
      }
    }
  }
  .dialog-footer {
    margin-top: 30px;
    display: flex;
    flex-direction: row-reverse;
  }
}
</style>
